const apiUrls = require('../../constants/apiUrls');

const orderStatus = {
    key: 'orderStatus',
    method: 'POST',
    getApiUrl: () => {
        return apiUrls.SERVICE_ORDER_STATUS_URL;
    },
    buildPostRequest: (request) => {
        return {
            serviceOrderIdList: [request.workOrderNumber]
        };

    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }
    ]
};

export default orderStatus;


// WEBPACK FOOTER //
// ./src/store/order-details-config/orderStatus.js